import { request } from "./client";

export function fetchDreamcastDigitalDelivery() {
  return request("/digital-delivery");
}

export function fetchDreamcastDigitalDeliveryById(id) {
  return request(`/digital-delivery/${id}`);
}

export function createDreamcastDigitalDelivery(body) {
  return request("/digital-delivery", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateDreamcastDigitalDelivery(id, body) {
  return request(`/digital-delivery/${id}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });
}

export function duplicateDreamcastDigitalDelivery(id) {
  return request(`/digital-delivery/${id}/duplicate`, {
    method: "POST",
  });
}

export function setDreamcastDigitalDeliveryStatus(
  id,
  workflowStatus,
  displayStatus,
) {
  return request(`/digital-delivery/${id}/status`, {
    method: "PATCH",
    body: JSON.stringify({ workflowStatus, displayStatus }),
  });
}
